import React from 'react'
import { useState, useEffect } from 'react'
import {Link, NavLink} from 'react-router-dom'
import {links} from '../data'
import {FaBars} from 'react-icons/fa'
import {MdOutlineClose} from 'react-icons/md'
import {BiDownArrow} from 'react-icons/bi'
import './navbar.css'

const Navbar = () => {

    const [isNavShowing, setIsNavShowing] = useState(false);

    useEffect(() => {

        addEvents();
    })

    window.addEventListener("scroll", () => {

        document.querySelector('nav').classList.toggle('window-scroll', window.scrollY > 0);
    })

/*=============== SHOW DROPDOWN MENU ===============*/
const addEvents = () => {

    const dropdownItems = document.querySelectorAll('.dropdown__item')

    dropdownItems.forEach((item) => {

        const dropdownButton = item.querySelector('.dropdown__button') 

        item.addEventListener('click', () => {

            if (window.matchMedia("(max-width: 1118px)").matches) {

                const showDropdown = document.querySelector('.show-dropdown')
        
                toggleItem(item)

                if(showDropdown && showDropdown!== item) {

                    toggleItem(showDropdown)
                }
            }
        })

        item.addEventListener('mouseover', () => {

            if (window.matchMedia("(min-width: 1118px)").matches) {

                const showDropdown = document.querySelector('.show-dropdown')
        
                toggleItem(item)

                if(showDropdown && showDropdown!== item) {

                    toggleItem(showDropdown)
                }
            }
        })

        item.addEventListener('mouseout', () => {

            if (window.matchMedia("(min-width: 1118px)").matches) {

                closeMenu();
            }
        })
    })
}

const toggleItem = (item) =>{

    const dropdownContainer = item.querySelector('.dropdown__container')

    if(item.classList.contains('show-dropdown')) {

        dropdownContainer.removeAttribute('style')

        item.classList.remove('show-dropdown')

    } else {

        dropdownContainer.style.height = dropdownContainer.scrollHeight + 'px'

        item.classList.add('show-dropdown')
    }
}

const closeMenu = () => {

    setIsNavShowing(prev => !prev)

    const showDropdown = document.querySelector('.show-dropdown')

    if(showDropdown) {

        toggleItem(showDropdown)
    }
}

const closeNbackToTop = () => {

    closeMenu();

    scrollToTop();
}

const scrollToTop = () => {

    window.scrollTo(0, 0);
}

addEvents();

return (
    <nav>
        <div className="container nav__container">

            <Link to="/" className='logo' onClick={() => setIsNavShowing(false)}>
                <svg className='navLogo' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67.23 18.83"><defs><style>.cls-1</style></defs><title>Asset 2</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g id="Front_Andrew"><path class="cls-1" d="M17,16.68H14.15l-1.73-9L9.07,16.9H8L4.65,7.69l-1.8,9H0L3.36,0H4.93L8.53,11.23,12.06,0h1.56Z"/><path class="cls-1" d="M34.38,16.68H31.52l-1.73-9L26.43,16.9H25.37L22,7.69l-1.8,9H17.36L20.72,0h1.57L25.9,11.23,29.42,0H31Z"/><path class="cls-1" d="M38.46,13.25v1.1H35.6v-1.1Z"/><path class="cls-1" d="M39.57,15a4.25,4.25,0,0,0,1.85.46c.76,0,1.17-.32,1.17-.8s-.35-.72-1.23-1c-1.22-.43-2-1.1-2-2.17,0-1.26,1-2.22,2.79-2.22A4.52,4.52,0,0,1,44,9.56l-.37,1.34a3.51,3.51,0,0,0-1.54-.35c-.72,0-1.07.33-1.07.71s.42.68,1.37,1c1.3.48,1.91,1.16,1.91,2.2,0,1.23-1,2.28-3,2.28a4.82,4.82,0,0,1-2.09-.45Z"/><path class="cls-1" d="M45.36,13.12c0-.7,0-1.3,0-1.79h1.44l.08.74h0a2.05,2.05,0,0,1,1.78-.86c1.17,0,2.22,1,2.22,2.72,0,1.94-1.23,2.86-2.43,2.86A1.66,1.66,0,0,1,47,16.18h0v2.65H45.36ZM47,14.38a1.65,1.65,0,0,0,0,.35,1,1,0,0,0,1,.79c.72,0,1.15-.6,1.15-1.51s-.38-1.5-1.13-1.5a1,1,0,0,0-1,.84,1.28,1.28,0,0,0,0,.29Z"/><path class="cls-1" d="M54.92,16.67l-.1-.54h0a1.93,1.93,0,0,1-1.53.66,1.64,1.64,0,0,1-1.73-1.64c0-1.39,1.25-2.05,3.14-2V13c0-.28-.15-.69-1-.69a3,3,0,0,0-1.48.4l-.31-1.07A4.42,4.42,0,0,1,54,11.21a2.08,2.08,0,0,1,2.35,2.31v1.86a8.33,8.33,0,0,0,.08,1.3Zm-.2-2.52c-.87,0-1.55.2-1.55.84a.6.6,0,0,0,.66.63.91.91,0,0,0,.86-.61,1.18,1.18,0,0,0,0-.28Z"/><path class="cls-1" d="M61.66,16.54a4.06,4.06,0,0,1-1.49.24A2.59,2.59,0,0,1,57.35,14a2.79,2.79,0,0,1,3.06-2.84,3.86,3.86,0,0,1,1.27.21l-.26,1.23a2.26,2.26,0,0,0-.93-.16A1.38,1.38,0,0,0,59.05,14a1.39,1.39,0,0,0,1.46,1.5,2.58,2.58,0,0,0,1-.16Z"/><path class="cls-1" d="M63.74,14.53c.05.69.73,1,1.51,1a4.72,4.72,0,0,0,1.48-.22l.22,1.13a5.27,5.27,0,0,1-1.93.33,2.56,2.56,0,0,1-2.85-2.72,2.68,2.68,0,0,1,2.7-2.85,2.37,2.37,0,0,1,2.38,2.67,3.92,3.92,0,0,1-.05.66Zm2-1.14a1,1,0,0,0-.94-1.08,1.09,1.09,0,0,0-1,1.08Z"/></g></g></g></svg>
            </Link>

            <ul className={`nav__links ${isNavShowing ? 'show__nav' : 'hide__Nav'}`}>
                {
                    links.map(({name, path, children}, index) => {
                        if (!children) {
                            return (
                                <li key={index}>
                                    <NavLink to={path} className={({isActive}) => isActive ? 'active-nav' : ''}  onClick={() => closeNbackToTop()}>{name}</NavLink>
                                </li>
                            );
                        } else {
                            return(
                                <div className='dropdown__item'>
                                    <li key={index}>
                                        <NavLink className={`dropdown__button` }>{name}
                                            <BiDownArrow className='dropdown__arrow'/>
                                        </NavLink>
                                    </li>
                                    <div className='dropdown__container'>
                                        <div className='dropdown__content'>
                                            <div className='dropdown__group'>
                                            {
                                                children.map(({name, path}, index) => {
                                                return (
                                                    <li key={index}>
                                                        <NavLink to={path} className="dropdown__link" onClick={() => closeNbackToTop()}>{name}</NavLink>
                                                    </li>
                                                    )
                                                })
                                            }
                                            </div>
                                        </div>
                                    </div> 
                                </div>
                            );
                        }
                    })
                }
            </ul>

            <button className={`nav__toggle-btn`} onClick={() => closeMenu()}>
                {
                    isNavShowing ? <MdOutlineClose /> : <FaBars />
                }
            </button>
        </div>
    </nav>
  )
}

export default Navbar 